import React from 'react';

import Authenticated from './Authenticated';
import AuthenticatedNativo from './AuthenticatedNativo';
import { AuthenticatedOTP } from './AuthenticatedOTP';

import {
  isShouldCheckLoggedInNative,
  setShouldCheckLoggedInNative,
} from '@/services';
import { isAndroid } from '@/utils/functions';

/**
 * ver doc en useAuth
 * @link {useAuth}
 */
const AuthenticatedWrapper: React.FC = React.memo(() => {
  const isAndroid2 = isAndroid();
  const params = new URLSearchParams(location.search);
  const hashLogin: string | null =
    params.get('hashLogin') || params.get('hash');
  if (hashLogin) {
    setShouldCheckLoggedInNative(false);
  }
  const checkSessionJava = isShouldCheckLoggedInNative();

  if (isAndroid2 || checkSessionJava) {
    return <AuthenticatedNativo />;
  } else if (hashLogin) {
    return <AuthenticatedOTP hashLogin={hashLogin || undefined} />;
  } else {
    return <Authenticated />;
  }
});

AuthenticatedWrapper.displayName = 'AuthenticatedWrapper';

export default AuthenticatedWrapper;
